import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const benefits = [
  'Clear communication',
  'Organized workflows',
  'Real-time collaboration',
  'Lower software costs',
];

export const Benefits = () => {
  return (
    <section id="benefits" className="py-20 bg-[#F8FAFC]" data-testid="benefits-section">
      <div className="container-main">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <span className="section-label section-label-orange">THE RESULT</span>
          <h2 className="text-3xl sm:text-4xl lg:text-[42px] font-bold text-[#1E293B] leading-tight mb-6">
            What Work Feels Like with BoardChat
          </h2>
          <p className="text-[#64748B] text-lg max-w-2xl mx-auto leading-relaxed">
            Imagine opening one platform and seeing everything your team is working on — 
            tasks, messages, and progress — all connected. Everyone knows what's happening, 
            and nothing slips through the cracks.
          </p>
        </motion.div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto mb-12">
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit}
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="flex items-center gap-3 bg-white border border-gray-200 rounded-xl px-5 py-4"
              data-testid={`benefit-${index}`}
            >
              <div className="benefit-check">
                <Check className="w-4 h-4" />
              </div>
              <span className="text-[#1E293B] font-medium">{benefit}</span>
            </motion.div>
          ))}
        </div>

        {/* Testimonial */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <blockquote className="text-[#64748B] text-lg italic max-w-2xl mx-auto">
            "BoardChat keeps our team connected and projects moving — without the chaos."
          </blockquote>
        </motion.div>
      </div>
    </section>
  );
};
